import { render, staticRenderFns } from "./otpcode.vue?vue&type=template&id=07178c7e&scoped=true&"
import script from "./otpcode.vue?vue&type=script&lang=js&"
export * from "./otpcode.vue?vue&type=script&lang=js&"
import style0 from "./otpcode.vue?vue&type=style&index=0&id=07178c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07178c7e",
  null
  
)

export default component.exports